import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CallCard.module.css';

interface CallHoldControlsProps {
  isLoading: string | null;
  onResume: () => void;
  onEnd: () => void;
}

export function CallHoldControls({ isLoading, onResume, onEnd }: CallHoldControlsProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.callControlsGrid}>
      <button
        className={`${styles.actionBtn} ${styles.btnHold} ${styles.onHold}`}
        onClick={onResume}
        disabled={isLoading !== null}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polygon points="5 3 19 12 5 21 5 3" />
        </svg>
        <span>{t('call:actions.resume')}</span>
      </button>

      <button
        className={`${styles.actionBtn} ${styles.btnDrop}`}
        onClick={onEnd}
        disabled={isLoading !== null}
        style={{ gridColumn: 'span 2' }}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M10.68 13.31a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92V20a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07M1 1l22 22" />
        </svg>
        {t('call:actions.endCall')}
      </button>
    </div>
  );
}

export default CallHoldControls;
